
/**
 * 약관 조회 응답
 */
export interface TermsResponse {
  /** 개인정보 수집·이용 약관 내용 */
  collectPersonalInfo: string;
  /** 전자금융거래 약관 내용 */
  electronicFinancialTransactions: string;
  /** 개인정보 제3자 제공 약관 내용 */
  sharingPersonalInformation: string;
  /** 통신과금 서비스 약관 내용 */
  telecommunicationCharging: string;
}
